import React from "react";
import { useRef, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import {
  AccordionContent,
  AccordionPanel,
  AccordionTitle,
} from "flowbite-react";
import EditInputField from "../EditInputField";
import { BsThreeDotsVertical } from "react-icons/bs";

export const AccordionCard = ({
  id,
  index,
  data,
  moveCard,
  formState,
  setFormState,
  children,
  dataProperty,
  handleInputChange,
}) => {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const [, drop] = useDrop({
    accept: "card",
    hover(item, monitor) {
      if (!ref.current) return;

      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) return;

      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset) return;

      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;

      moveCard(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "card",
    item: { id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 1 : 1;
  drag(drop(ref));

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };

  const getType = (name) => {
    return dataProperty?.find((data) => data?.name === name)?.fieldType;
  };

  const getOption = (name) => {
    return dataProperty?.find((data) => data?.name === name)?.options;
  };

  return (
    <div ref={ref} style={{ opacity }} className="w-full m-1 relative">
      <AccordionPanel key={index} isOpen={isOpen} applyTheme={false}>
        <AccordionTitle
          className="bg-canvas-primary/15 my-1 cursor-pointer h-12"
          onClick={toggleAccordion}
        >
          <div className="flex items-center gap-2 w-full">
            <BsThreeDotsVertical className="text-canvas-primary flex-shrink-0 -ml-4" />
            <span className="font-outfit text-sm uppercase font-bold text-canvas-primary">
              {data?.title}
            </span>
          </div>
        </AccordionTitle>
        {isOpen && (
          <AccordionContent className="border border-gray-500 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 align-bottom items-end">
            {data?.content?.map((item, i) => {
              return (
                <EditInputField
                  disabled={item?.disabled}
                  key={i}
                  label={item?.label}
                  name={item?.name}
                  value={formState[item.name]}
                  onChange={handleInputChange}
                  required={item?.required}
                  type={item?.type ? item?.type : getType(item?.name)}
                  options={getOption(item?.name)}
                />
              );
            })}
          </AccordionContent>
        )}
      </AccordionPanel>
    </div>
  );
};
